import { useNavigate } from "react-router-dom";
import { Tabs, TabsProps } from "antd";

import { useAppSelector } from "store";
import { getUserSelector } from "store/user/user.selector";

import "./SettingsHeader.scss";

interface IProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
}

const SettingsHeader = ({ activeTab, setActiveTab }: IProps) => {
  const navigate = useNavigate();
  const { meta } = useAppSelector(getUserSelector);

  const onChangeTab = (value: string) => {
    setActiveTab(value);

    navigate(`/settings/${ value }`);
  };

  const allTabs: TabsProps[ "items" ] = [
    {
      key: "general",
      label: "General settings",
    },
    {
      key: "profile",
      label: "My profile",
    },
    {
      key: "company-details",
      label: "Company details",
    },
    {
      key: "team",
      label: "Team",
    },
    {
      key: "email-sender",
      label: "Email Sender",
    },
    // {
    //   key: "password",
    //   label: "Password",
    // },
    // {
    //   key: "help-support",
    //   label: "Help & Support",
    // },
    // {
    //   key: "notifications",
    //   label: "Notifications",
    // },
  ];

  const tabs = allTabs.filter(tab => {
    if (tab.key === "email-sender") {
      return Boolean(meta?.settings?.email_sender);
    }
    return true;
  });

  return (
    <div className="settings-header">
      <Tabs
        className="settings-header-tabs"
        items={ tabs }
        activeKey={ activeTab }
        onChange={ onChangeTab }
        animated={ false }
      />
    </div>
  );
};

export default SettingsHeader;
